export enum Environment {
  Atest = 'atest',
  Development = 'development',
  Feature = 'feature',
  Local = 'local',
  Production = 'production',
  PTest = 'ptest',
  TreasuryStaging = 'treasury-staging'
}

export type EnvironmentLabel = keyof typeof Environment;
